import {PageHeader} from '../ui/PageHeader';
import { Link, useSearchParams } from 'react-router';
import { Permissions as P } from '@myfm/domain';
import { useStaffSession } from '../ui/StaffSession';
export function AlphaHome() {
  const session = useStaffSession(),
    [q, setQ] = useSearchParams(),
    building = q.get('building') ?? '',
    scope = building ? '?building=' + encodeURIComponent(building) : '';
  const links = [
    ['Share director decisions', '/alpha/director-publication', P.ManageGovernance],
    ['Share budget approvals', '/alpha/budget-publication', P.ManageServiceChargeFinance],
    ['Conveyancing cases', '/alpha/conveyancing', P.ViewCommunications],
    ['Prepare board and AGM packs', '/alpha/board-packs', P.ViewOperationalReporting],
    ['Resident appointments and updates', '/alpha/resident-appointments', P.ManageWork],
    ['Building notices', '/alpha/building-notices', P.ManageCommunications],
    ['Payment-plan requests', '/alpha/payment-plans', P.ApproveServiceChargeFinance],
    ['Sandbox bank feed', '/alpha/bank-feeds', P.ManageBankReconciliation],
    ['Leaseholder contacts and documents', '/alpha/households', P.ViewMaster],
    ['Complaint reviews', '/alpha/complaints', P.ViewCommunications],
    ['Building incidents', '/alpha/incidents', P.ViewWork],
    ['Warranty recovery', '/alpha/warranties', P.ViewWork],
    ['Refund requests', '/alpha/refunds', P.ViewFinance],
    ['Information requests', '/alpha/information', P.ViewCommunications],
    ['Resident polls', '/alpha/polls', P.ViewCommunications],
    ['WhatsApp', '/alpha/whatsapp', P.ViewCommunications],
    ['Outgoing handovers', '/alpha/handovers', P.ViewCommunications],
    ['Workload, staffing and building comparisons', '/alpha/planning', P.ViewOperationalReporting],
    ['Year-end accountant reviews', '/alpha/year-end', P.ViewAccountingReports],
    ['Year-end balancing', '/alpha/year-end-balancing', P.ViewFinance],
    ['Reconcile card payments', '/alpha/card-payments', P.ViewFinance],
    ['Service-contract renewal decisions', '/alpha/contract-renewals', P.ManageContractors],
    ['Supplier performance reviews', '/alpha/supplier-performance', P.ManageContractors],
    ['Reserve forecasts', '/alpha/reserve-forecasts', P.ViewFinance],
    ['Building evidence assistant', '/alpha/building-assistant', P.ViewMaster],
    ['Meetings and AGM', '/alpha/meetings', P.ViewGovernance],
    ['Alterations applications', '/alpha/consents', P.ViewCommunications],
    ['Resident case reviews', '/alpha/resident-cases', P.ViewCommunications],
    ['Company administration', '/alpha/company', P.ViewGovernance],
    ['Utility exceptions', '/alpha/utility-exceptions', P.ViewMaster],
  ] as const;
  const available = links.filter((l) => session?.capabilities.includes(l[2])),
    renewals = session?.capabilities.includes(P.ManageContractors),
    simulations = session?.capabilities.includes(P.ViewPlatformOperations);
  return (
    <>
      <PageHeader title={available.length || renewals || simulations ? 'Feature previews' : 'Your portal'}/>
      <section className="panel">
        <h2>Your information</h2>
        <ul>
          <li>
            <Link to="/portal/decisions">Director decisions</Link>
          </li>
          <li>
            <Link to="/portal/budgets">Budget decisions</Link>
          </li>
          <li>
            <Link to="/portal/accountant-reviews">Accountant reviews</Link>
          </li>
          <li>
            <Link to="/portal/home">Your home, accounts and requests</Link>
          </li>
          <li>
            <Link to="/portal/notices">Building notices</Link>
          </li>
          {building && (
            <li>
              <Link to={'/portal/board-packs' + scope}>Published board packs</Link>
            </li>
          )}
        </ul>
      </section>
      {(available.length > 0 || renewals || simulations) && (
        <section className="panel">
          <h2>Prepare and manage</h2>
          <p>
            <a href="/offline/index.html">Offline field reports</a>
          </p>
          <label>
            Building
            <select
              value={building}
              onChange={(e) => setQ(e.target.value ? { building: e.target.value } : {})}
            >
              <option value="">Choose a building</option>
              {session?.buildings.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>
          </label>
          {building ? (
            <ul>
              {available.map((l) => (
                <li key={l[1]}>
                  <Link to={l[1] + scope}>{l[0]}</Link>
                </li>
              ))}
            </ul>
          ) : (
            <p>Choose a building to open its workflows.</p>
          )}
          {renewals && <Link to="/alpha/supplier-renewals">Supplier evidence renewals</Link>}
          {simulations && (
            <p>
              <Link to="/alpha/rule-simulations">Automation rule simulation</Link>
            </p>
          )}
        </section>
      )}
    </>
  );
}
